import React, { useState, useRef, useEffect } from "react";
import styles from "./FeedCommentInput.module.css";

interface FeedCommentInputProps {
  onSubmit: (comment: string) => void;
  placeholder?: string;
}

const FeedCommentInput: React.FC<FeedCommentInputProps> = ({
  onSubmit,
  placeholder = "집사님의 댓글을 기다리고 있어요",
}) => {
  const [comment, setComment] = useState("");
  const [isComposing, setIsComposing] = useState(false);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    textarea.style.height = "auto";
    const newHeight = Math.min(textarea.scrollHeight, 72); // 3줄 제한 (24px * 3)
    textarea.style.height = `${newHeight}px`;
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setComment(e.target.value);
    adjustHeight();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey && !isComposing) {
      e.preventDefault();
      if (comment.trim()) {
        handleSubmit(e);
      }
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (comment.trim()) {
      onSubmit(comment);
      setComment("");
      if (textareaRef.current) {
        textareaRef.current.style.height = "30px"; // 초기 높이로 리셋
      }
    }
  };

  // 컴포넌트 마운트 시 초기 높이 설정
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "30px";
    }
  }, []);

  return (
    <form className={styles.commentForm} onSubmit={handleSubmit}>
      <textarea
        ref={textareaRef}
        value={comment}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onCompositionStart={() => setIsComposing(true)}
        onCompositionEnd={() => setIsComposing(false)}
        placeholder={placeholder}
        className={styles.commentInput}
        rows={1}
      />
      <button
        type="submit"
        className={styles.submitButton}
        disabled={!comment.trim()}
      >
        게시
      </button>
    </form>
  );
};

export default FeedCommentInput;
